export function getSuccessPercent(
  succeeded: number,
  failed: number,
  other: number,
) {
  const total = succeeded + failed + other;

  if (total === 0) {
    return 0;
  }

  return Math.round((succeeded / total) * 100);
}

export function getSuccessRateColor(percent: number) {
  if (percent < 60) {
    return '#ff4d4f';
  }

  if (percent <= 80) {
    return '#faad14';
  }

  return '#1677ff';
}
